// extracted by mini-css-extract-plugin
export default {"rankBattleModal":"RankBattleModal_rankBattleModal__5gqwj","body":"RankBattleModal_body__ihzfS"};